<template>
  <b-modal
    ref="modal"
    :title="title"
    size="lg"
    hide-footer
    centered>
    <div class="p-1">
      <b-form-group label="Aula">
        <b-form-select v-model="lessonId" :options="lessonOptions" @change="loadImpact"/>
      </b-form-group>

      <b-form-group :label="$t('cancellation.club_cancel_reason')">
        <b-form-select v-model="reason" :options="reasonOptions" class="required"/>
      </b-form-group>

      <div class="border rounded p-1 mb-2" v-if="impact">
        <div class="font-medium mb-1">{{ $t('cancellation.club_cancel_impact') }}</div>
        <div class="flex justify-between mb-50">
          <small class="text-muted">{{ $t('cancellation.club_cancel_students') }}</small>
          <small>{{ impact.affected_students }}</small>
        </div>
        <div class="flex justify-between mb-50">
          <small class="text-muted">{{ $t('cancellation.club_cancel_refund') }}</small>
          <small>{{ formatValue(impact.full_refund_total) }}</small>
        </div>
        <div class="flex justify-between mb-50">
          <small class="text-muted">{{ $t('cancellation.club_cancel_transfer') }}</small>
          <small>{{ formatValue(impact.settled_transfer_reversal) }}</small>
        </div>
        <div class="flex justify-between">
          <small class="text-muted">{{ $t('cancellation.club_cancel_fee') }}</small>
          <small>{{ formatValue(impact.hubee_fee_returned) }}</small>
        </div>
      </div>

      <div class="flex justify-between items-center border rounded p-1 mb-2">
        <div>
          <div>{{ $t('cancellation.club_cancel_mass_reschedule') }}</div>
          <small class="text-muted">{{ $t('cancellation.club_cancel_mass_hint') }}</small>
        </div>
        <b-form-checkbox v-model="offerReschedule" switch/>
      </div>

      <b-alert show variant="danger" class="p-1 mb-2">
        <div class="flex items-start">
          <feather-icon icon="AlertTriangleIcon" class="mr-1 flex-shrink-0"/>
          <small>{{ $t('cancellation.club_cancel_warning') }}</small>
        </div>
      </b-alert>

      <div class="flex justify-end gap-4">
        <b-button variant="outline-secondary" class="mr-2" @click="close">
          {{ $t('back') }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="!impact || !impact.affected_students"
          @click="execute">
          {{ $t('cancellation.club_cancel_confirm', { count: impact ? impact.affected_students : 0 }) }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BAlert,
  BButton,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  BModal
} from 'bootstrap-vue'
import { currencyFormatter } from '@/util/Util'

import CancellationRequestService from '@/services/api/CancellationRequestService'
import LessonService from '@/services/api/LessonService'

export default {
  components: {
    BAlert,
    BButton,
    BFormCheckbox,
    BFormGroup,
    BFormSelect,
    BModal
  },
  data: () => ({
    service: null,
    lessonService: null,
    lessons: [],
    lessonId: null,
    reason: 'Professor indisponível',
    reasonOptions: [
      'Professor indisponível',
      'Manutenção do espaço',
      'Clima',
      'Baixa ocupação',
      'Outro'
    ],
    offerReschedule: true,
    impact: null
  }),
  computed: {
    title() {
      const lesson = this.lessons.find(item => item.id === this.lessonId)
      return this.$t('cancellation.club_cancel_title') + (lesson ? ` · ${lesson.name}` : '')
    },
    lessonOptions() {
      return this.lessons.map(lesson => ({ value: lesson.id, text: lesson.name }))
    }
  },
  methods: {
    open() {
      this.impact = null
      this.lessonId = null
      this.$refs.modal.show()
      this.loadLessons()
    },
    close() {
      this.$refs.modal.hide()
    },
    loadLessons() {
      this.lessonService.grid('', { page: 1, per_page: 50 }).then(response => {
        this.lessons = this._.get(response, 'model.data', [])
      })
    },
    loadImpact() {
      if (!this.lessonId) return
      this.service.clubCancelImpact({ lesson_id: this.lessonId }).then(
        impact => { this.impact = impact },
        () => {}
      )
    },
    execute() {
      this.$vs.loading()
      const lesson = this.lessons.find(item => item.id === this.lessonId)
      this.service.clubCancelExecute({
        lesson_id: this.lessonId,
        reason: this.reason,
        offer_reschedule: this.offerReschedule,
        session_label: lesson ? lesson.name : null
      }).then(
        () => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.close()
          this.$emit('executed')
        },
        () => {}
      ).finally(() => { this.$vs.loading.close() })
    },
    formatValue(value) {
      return currencyFormatter(value || 0)
    }
  },
  beforeMount() {
    this.service = CancellationRequestService.build(this.$vs)
    this.lessonService = LessonService.build(this.$vs)
  }
}
</script>
